import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  dsn: "https://06595d335f8545f18001243563330732@o4504733989404672.ingest.sentry.io/4504848116088832",
  integrations: [
    Sentry.replayIntegration({ maskAllText: false, minReplayDuration: 15000 }),
  ],
  sampleRate: 0.25,
  environment: environment.sentryEnvironment,
  enabled: environment.sentryEnabled,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
